import React, { useState } from 'react';
import { BellOff, Plus } from 'lucide-react';
import Badge from '../../../../ui/Badge';
import ButtonSpinner from '../../../../ui/ButtonSpinner';
import CardImage from '../../../../ui/CardImage';
import ContextMenu from '../../../../ui/ContextMenu';
import CardPreview from '../CardPreview';

/**
 * Kompakte Vorschlags-Zeile der Brücke: Miniatur links, rechts Name, Begründungs-Chips
 * (zwei Zeilen, Rest abgeschnitten) und der Plus-Knopf. Kein ✕ — „nicht vorschlagen"
 * verwaltet man im Katalog, wo auch der Weg zurück steht.
 *
 * Die Miniatur ist zu klein zum Lesen: Wer mit der Maus über Bild oder Namen fährt, bekommt
 * die Karte als Hover-Vorschau (`CardPreview`, dieselbe wie in Kompakt- und Tabellenansicht).
 */
export default function BridgeSuggestionRow({ entry, adding = false, onAdd, onOpen, onMuteTag }) {
  const [vorschauPosition, setVorschauPosition] = useState(null);
  const vorschauGriffe = {
    onMouseEnter: (event) => setVorschauPosition({ x: event.clientX, y: event.clientY }),
    onMouseMove: (event) => setVorschauPosition({ x: event.clientX, y: event.clientY }),
    onMouseLeave: () => setVorschauPosition(null),
  };

  return (
    <div className="bridge-suggestion-row">
      <div className="bridge-suggestion-row__image" {...vorschauGriffe}>
        <CardImage src={entry.imageUrl} backSrc={entry.imageUrlBack || undefined} alt={entry.name} onOpen={() => onOpen?.(entry)} />
      </div>
      <div className="bridge-suggestion-row__body">
        <div className="bridge-suggestion-row__head">
          <button type="button" className="bridge-suggestion-row__name" onClick={() => onOpen?.(entry)} {...vorschauGriffe}>{entry.name}</button>
          <button
            type="button"
            className="btn-icon"
            aria-label={`${entry.name} hinzufügen`}
            title="Zum Deck hinzufügen"
            aria-busy={adding || undefined}
            onClick={() => { if (!adding) onAdd?.(entry); }}
          >
            {adding ? <ButtonSpinner /> : <Plus size={16} aria-hidden />}
          </button>
        </div>
        <div className="bridge-suggestion-row__reasons">
          {(entry.reasons || []).map((grund) => (
            <ContextMenu
              key={grund.tagId}
              trigger={<Badge button title={grund.description || undefined}>{grund.label}</Badge>}
            >
              <ContextMenu.Item icon={BellOff} onSelect={() => onMuteTag?.(grund.tagId)}>
                Thema stummschalten
              </ContextMenu.Item>
            </ContextMenu>
          ))}
        </div>
      </div>
      <CardPreview card={entry} position={vorschauPosition} />
    </div>
  );
}
